const read = (name, fallback = '') => {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
};

export const firebaseConfig = {
  apiKey: read('VITE_FIREBASE_API_KEY'),
  authDomain: read('VITE_FIREBASE_AUTH_DOMAIN'),
  databaseURL: read('VITE_FIREBASE_DATABASE_URL'),
  projectId: read('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: read('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: read('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: read('VITE_FIREBASE_APP_ID'),
  measurementId: read('VITE_FIREBASE_MEASUREMENT_ID'),
};

export const appUrl = read('VITE_APP_URL');
export const stripePublishableKey = read('VITE_STRIPE_PUBLISHABLE_KEY');
export const googleMapsApiKey = read('VITE_GOOGLE_MAPS_API_KEY');
export const googleMapsMapId = read('VITE_GOOGLE_MAPS_MAP_ID');
export const firebaseVapidKey = read('VITE_FIREBASE_VAPID_KEY');

const requiredFirebaseKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];

export const missingFirebaseConfig = requiredFirebaseKeys.filter(
  (key) => !firebaseConfig[key],
);

export const isFirebaseConfigured = missingFirebaseConfig.length === 0;
